export default __webpack_public_path__ + "static/media/videoMp4.b3dc6cfd.mp4";